import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type Type = "bus" | "people";

interface IState {
  visible: boolean;
  selectedInventory: any;
}

const initialState: IState = {
  visible: false,
  selectedInventory: {},
};

export const supportInventorySlice = createSlice({
  name: "supportInventory",
  initialState,
  reducers: {
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    selectInventory: (state, action: PayloadAction<any>) => {
      return { ...state, selectedInventory: action.payload };
    },
  },
});

export const { toggleVisibility, selectInventory } = supportInventorySlice.actions;

export default supportInventorySlice.reducer;
